import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import {imgSize} from "../../../../config/values";
import FolderIcon from '@material-ui/icons/Folder';
import Button from "@material-ui/core/Button/Button";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {setStore} from "trim-redux";
import AddDirectoryButton from "./AddDirectoryButton";
import Breadcrumbs from "@material-ui/core/Breadcrumbs/Breadcrumbs";
import DirectorySettingButton from "./DirectorySettingButton";
import FolderOpenRoundedIcon from '@material-ui/icons/FolderOpenRounded';
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
class SingleFileChooser extends React.Component {
    classes = this.props.classes;
    state = {
        loading:true,
        directories:[],
        current_directory:null,
        history:[
            {
                name: Translate.all,
                id:null
            }
        ]
    }
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        this.setState({
            loading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let {current_directory} = this.state;
        this.props.handleCurrentDirectory(current_directory);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/files-directories/getAll${!!current_directory ? "/"+current_directory : '' }`, config)
                .then(response => {
                    this.setState({
                        directories:response.data,
                        loading:false
                    })
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }
    }
    classes = this.props.classes;
    async handleClick(directory){
        let {history} = this.state;
        await history.push({
            name: directory.name,
            id:directory.id
        })
        await this.setState({
            current_directory:directory.id,
            history
        })
        await this.loadData()
    }
    async handleClickBread(item){
        let {history} = this.state;
        let new_history = [];
        let dont_resume = false;
        await history.map((bread) => {
            if(!dont_resume){
                new_history.push(bread);
            }
            if(bread.id === item.id){
                dont_resume = true;
            }
        })
        await this.setState({
            history:new_history,
            current_directory:item.id
        })
        await this.loadData()
    }
    changeHistory(data){
        let {history} = this.state;
        history[history.length - 1].name = data.name;
        this.setState({
            history
        })
        this.loadData();
    }
    render(){
        let {loading,directories,current_directory,history} = this.state;
        let {move} = this.props;
        let current = history[history.length - 1];
        return(
            <div className="filemanager-folder-section">
                {
                    !!loading ?
                        <AppCardLoaderFields height={100}/>
                        :
                    <>
                        <div className="bread-section">
                            <Typography>
                                {Translate.currentDirectory}:
                            </Typography>
                            <Breadcrumbs aria-label="breadcrumb">
                                {
                                    history.map((item,index) => (
                                        <Button
                                            color={current.id === item.id ? "secondary" : "primary"}
                                            key={index}
                                            size="small"
                                            onClick={() => this.handleClickBread(item)}
                                        >
                                            {item.name}
                                        </Button>
                                    ))
                                }
                            </Breadcrumbs>
                            {
                                (!!current.id && !move) &&
                                <DirectorySettingButton
                                    current={current}
                                    reload={(data) => this.changeHistory(data)}
                                />
                            }
                        </div>
                        <div className="directories">
                            {
                                directories.map((directory,index) =>(
                                    <Button
                                        key={index}
                                        color="primary"
                                        size="small"
                                        variant="outlined"
                                        onClick={() => this.handleClick(directory)}
                                        startIcon={<FolderOpenRoundedIcon/>}
                                        style={{marginLeft:10,marginBottom:10}}
                                    >
                                        {directory.name}
                                    </Button>
                                ))
                            }
                            <AddDirectoryButton
                                current_directory={current_directory}
                                reload={() => this.loadData()}
                                empty={directories.length === 0}
                                button
                            />

                        </div>
                    </>
                }

            </div>
        )

    }
}
export default withStyles(Styles)(SingleFileChooser);